<template>
    <main class="admin-page__content">
        <VContentHeaderDefault
            title="Группы ответственных"
            button="Создать группу ответственных"
            @search="onSearch"
            @button="onButtonClick"
        ></VContentHeaderDefault>

        <template v-if="isLoading">
            <div class="admin-page__loader">
                <VSpinner></VSpinner>
            </div>
        </template>

        <template v-else>
            <VContentTableDefault
                :rows="rows"
                :page="page"
                :total="total"
                :options="options"
                @page="onPageChange"
                @edit="onSecurityGroupClick"
                @click="onSecurityGroupClick"
            ></VContentTableDefault>
        </template>

        <VAdminSecurityGroupCard></VAdminSecurityGroupCard>
    </main>
</template>
<script>
// Components
import VSpinner from '../../components/VProgress/VSpinner.vue';
import PagePaginate from '../../components/PagePaginate/PagePaginate.vue';
import VAdminSecurityGroupCard from '../../modals/VAdminSecurityGroupCard.vue';
import VContentTableDefault from '../../components/VContentTableDefault.vue';
import VContentHeaderDefault from '../../components/VContentHeaderDefault.vue';
import './AdminPage.scss';

// Other
import Vue from 'vue';
import Component from 'vue-class-component';
import { errorMessage } from '../../../js/error';
import { Watch } from 'vue-property-decorator';
import ModalNames from '../../../js/enums/ModalNames';
import { createSecurityGroup, updateSecurityGroup, getAllSecurityGroups } from '../../../js/admin-api';

@Component({
    components: {
        VSpinner,
        PagePaginate,
        VAdminSecurityGroupCard,
        VContentTableDefault,
        VContentHeaderDefault,
    },
})
class AdminPageSecurityGroups extends Vue {
    rows = [];
    page = 1;
    total = 1;
    isLoading = true;
    searchString = '';
    options = {
        editable: true,
        deletable: false,
        columns: [
            {
                size: 5,
                label: '№',
                display: (x) => x.id,
            },
            {
                size: 20,
                label: 'Название',
                display: (x) => x.name,
            },
            {
                size: 15,
                label: 'Общее имя (Active Directory)',
                display: (x) => x.commonName,
            },
            {
                size: 15,
                label: 'Часовой пояс',
                display: (x) => x.timezone,
            },
            {
                size: 15,
                label: 'Количество участников',
                display: (x) => x.accounts.length,
            },
            {
                size: 20,
                label: 'Создан',
                display: (x) => this.$_toLocalDateHistory(x.createdAt),
            },
        ],
    };

    onSearch(searchString) {
        this.searchString = searchString;
    }

    onPageChange(page) {
        this.page = page;
    }

    async onSecurityGroupClick(securityGroup) {
        try {
            securityGroup = await this.$showModal(ModalNames.ADMIN_PANEL_SECURITY_GROUP_CARD, {
                securityGroup,
            });

            this.isLoading = true;

            try {
                await this.updateSecurityGroup(securityGroup);
                await this.fetchSecurityGroup();
            } catch (error) {
                let message = errorMessage(error);

                if (error?.response?.data?.errors?.name) {
                    message = 'Группа с таким именем уже существует';
                }

                this.$showModal(ModalNames.ERROR, { errorMessage: message });
            } finally {
                this.isLoading = false;
            }
        } catch (error) {
            // The modal was closed.
            return;
        }
    }

    async onButtonClick() {
        try {
            const securityGroup = await this.$showModal(ModalNames.ADMIN_PANEL_SECURITY_GROUP_CARD, {
                securityGroup: {
                    name: '',
                    commonName: '',
                    accounts: [],
                },
            });

            this.isLoading = true;

            try {
                await this.createSecurityGroup(securityGroup);
                await this.fetchSecurityGroup();
            } catch (error) {
                let message = errorMessage(error);

                if (error?.response?.data?.errors?.name) {
                    message = 'Группа с таким именем уже существует';
                }

                this.$showModal(ModalNames.ERROR, { errorMessage: message });
            } finally {
                this.isLoading = false;
            }
        } catch (error) {
            // The modal was closed.
            return;
        }
    }

    createSecurityGroup(user) {
        return createSecurityGroup(user);
    }

    updateSecurityGroup(user) {
        return updateSecurityGroup(user);
    }

    @Watch('page')
    @Watch('searchString')
    async fetchSecurityGroup() {
        this.isLoading = true;

        try {
            const response = await getAllSecurityGroups(this.page, this.searchString);

            this.rows = response.data.data;
            this.total = response.data.total;
        } catch (error) {
            const message = errorMessage(error);

            this.$showModal(ModalNames.ERROR, { errorMessage: message });
        } finally {
            this.isLoading = false;
        }
    }

    created() {
        this.fetchSecurityGroup();
    }
}

export default AdminPageSecurityGroups;
</script>
